var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEneryLowBattery(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5791 20.7539C13.5791 20.7539 14.7981 23.2489 16.8491 23.0609C21.0071 22.6809 20.7291 17.1539 22.2491 15.2019C20.9632 14.5616 19.5441 14.2347 18.1076 14.2477C16.6712 14.2607 15.2582 14.6134 13.9841 15.2769C11.8301 16.4939 11.6771 18.5479 13.5791 20.7539Z",
    stroke: "red",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.52 18.219C16.52 18.219 13.82 18.553 11.897 23.249",
    stroke: "red",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 23.25H3.5C3.10218 23.25 2.72064 23.092 2.43934 22.8107C2.15804 22.5294 2 22.1478 2 21.75V5.25C2 4.85218 2.15804 4.47064 2.43934 4.18934C2.72064 3.90804 3.10218 3.75 3.5 3.75H14C14.3978 3.75 14.7794 3.90804 15.0607 4.18934C15.342 4.47064 15.5 4.85218 15.5 5.25V12",
    stroke: "red",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 0.75H10.75C11.0152 0.75 11.2696 0.855357 11.4571 1.04289C11.6446 1.23043 11.75 1.48478 11.75 1.75V3.75H5.75V1.75C5.75 1.48478 5.85536 1.23043 6.04289 1.04289C6.23043 0.855357 6.48478 0.75 6.75 0.75Z",
    stroke: "red",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEneryLowBattery);
export default __webpack_public_path__ + "static/media/enery_low_battery.12d3e49f21f2640bf6032f4807875a2c.svg";
export { ForwardRef as ReactComponent };